import { Client, Coach } from "@/types/page";

export const APPOINTMENT_DURATION_MINUTES = 50;

export type Appointment = {
    id: number;
    start_at: string;
    end_at: string;
    client: Client;
    coach: Coach;
    can: {
        delete: boolean;
        reschedule: boolean;
    };
    is_conflicted: boolean;
    actually_happened: boolean | null;
    display_status?: "successful" | "missed" | "hidden";
    recurring_appointment_slot_id: number | null;
    used_goals_board: boolean;
    is_coach_assistant_disabled: boolean;
};
